var _path, _g, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 84,
    viewBox: "0 0 43 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_623_2975",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 15,
    width: 37,
    height: 52
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.4223 57.2336V66.1016H4.76891V58.5979L20.7313 41.8169C22.1411 40.2024 23.278 38.7586 24.1421 37.4852C25.0061 36.1891 25.6315 35.0181 26.018 33.9721C26.4273 32.9261 26.632 31.9825 26.632 31.1412C26.632 29.7086 26.4159 28.5149 25.9839 27.5599C25.5746 26.5821 24.9607 25.8431 24.1421 25.3429C23.3462 24.8426 22.3571 24.5925 21.1747 24.5925C19.9923 24.5925 18.9577 24.9336 18.0709 25.6157C17.1841 26.2979 16.4906 27.2301 15.9903 28.4125C15.5128 29.595 15.2741 30.9252 15.2741 32.4032H3.74568C3.74568 29.3562 4.48468 26.5707 5.96268 24.0468C7.46342 21.5228 9.54399 19.5104 12.2044 18.0097C14.8648 16.4862 17.9459 15.7245 21.4476 15.7245C25.1085 15.7245 28.1782 16.2929 30.6567 17.4299C33.1352 18.5668 34.9997 20.2153 36.2503 22.3755C37.5237 24.5129 38.1604 27.0937 38.1604 30.1179C38.1604 31.8461 37.8875 33.506 37.3418 35.0977C36.796 36.6894 36.0116 38.2697 34.9883 39.8386C33.9651 41.3848 32.7145 42.9765 31.2365 44.6137C29.7812 46.2509 28.1213 47.9904 26.2568 49.8322L19.8445 57.2336H39.4223Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_623_2975)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -22.7305,
    y: -2.64062,
    width: 44.7021,
    height: 44.7021,
    fill: "#DB4437"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -22.7305,
    y: 42.0615,
    width: 44.7021,
    height: 44.7021,
    fill: "#0F9D56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.9688,
    y: -2.64062,
    width: 44.7021,
    height: 44.7021,
    fill: "#F4B400"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.9688,
    y: 42.0615,
    width: 44.7021,
    height: 44.7021,
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.37286,
    cy: 17.4236,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.49396,
    cy: 17.4236,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.6111,
    cy: 17.4236,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.7322,
    cy: 17.4236,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.8494,
    cy: 17.4236,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.9666,
    cy: 17.4236,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.0838,
    cy: 17.4236,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.2049,
    cy: 17.4236,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.3221,
    cy: 17.4236,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.4432,
    cy: 17.4236,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.5643,
    cy: 17.4236,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.37286,
    cy: 20.5408,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.49396,
    cy: 20.5408,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.6111,
    cy: 20.5408,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.7322,
    cy: 20.5408,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.8494,
    cy: 20.5408,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.9666,
    cy: 20.5408,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.0838,
    cy: 20.5408,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.2049,
    cy: 20.5408,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.3221,
    cy: 20.5408,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.4432,
    cy: 20.5408,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.5643,
    cy: 20.5408,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.37286,
    cy: 23.66,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.49396,
    cy: 23.66,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.6111,
    cy: 23.66,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.7322,
    cy: 23.66,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.8494,
    cy: 23.66,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.9666,
    cy: 23.66,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.0838,
    cy: 23.66,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.2049,
    cy: 23.66,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.3221,
    cy: 23.66,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.4432,
    cy: 23.66,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.5643,
    cy: 23.66,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.37286,
    cy: 26.7791,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.49396,
    cy: 26.7791,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.6111,
    cy: 26.7791,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.7322,
    cy: 26.7791,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.8494,
    cy: 26.7791,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.9666,
    cy: 26.7791,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.0838,
    cy: 26.7791,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.2049,
    cy: 26.7791,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.3221,
    cy: 26.7791,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.4432,
    cy: 26.7791,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.5643,
    cy: 26.7791,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.37286,
    cy: 29.8992,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.49396,
    cy: 29.8992,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.6111,
    cy: 29.8992,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.7322,
    cy: 29.8992,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.8494,
    cy: 29.8992,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.9666,
    cy: 29.8992,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.0838,
    cy: 29.8992,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.2049,
    cy: 29.8992,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.3221,
    cy: 29.8992,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.4432,
    cy: 29.8992,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.5643,
    cy: 29.8992,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.37286,
    cy: 33.0174,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.49396,
    cy: 33.0174,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.6111,
    cy: 33.0174,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.7322,
    cy: 33.0174,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.8494,
    cy: 33.0174,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.9666,
    cy: 33.0174,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.0838,
    cy: 33.0174,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.2049,
    cy: 33.0174,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.3221,
    cy: 33.0174,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.4432,
    cy: 33.0174,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.5643,
    cy: 33.0174,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.37286,
    cy: 36.1346,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.49396,
    cy: 36.1346,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.6111,
    cy: 36.1346,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.7322,
    cy: 36.1346,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.8494,
    cy: 36.1346,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.9666,
    cy: 36.1346,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.0838,
    cy: 36.1346,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.2049,
    cy: 36.1346,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.3221,
    cy: 36.1346,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.4432,
    cy: 36.1346,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.5643,
    cy: 36.1346,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.37286,
    cy: 39.2547,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.49396,
    cy: 39.2547,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.6111,
    cy: 39.2547,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.7322,
    cy: 39.2547,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.8494,
    cy: 39.2547,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.9666,
    cy: 39.2547,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.0838,
    cy: 39.2547,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.2049,
    cy: 39.2547,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.3221,
    cy: 39.2547,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.4432,
    cy: 39.2547,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.5643,
    cy: 39.2547,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.37286,
    cy: 42.3729,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.49396,
    cy: 42.3729,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.6111,
    cy: 42.3729,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.7322,
    cy: 42.3729,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.8494,
    cy: 42.3729,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.9666,
    cy: 42.3729,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.0838,
    cy: 42.3729,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.2049,
    cy: 42.3729,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.3221,
    cy: 42.3729,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.4432,
    cy: 42.3729,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.5643,
    cy: 42.3729,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.37286,
    cy: 45.4901,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.49396,
    cy: 45.4901,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.6111,
    cy: 45.4901,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.7322,
    cy: 45.4901,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.8494,
    cy: 45.4901,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.9666,
    cy: 45.4901,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.0838,
    cy: 45.4901,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.2049,
    cy: 45.4901,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.3221,
    cy: 45.4901,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.4432,
    cy: 45.4901,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.5643,
    cy: 45.4901,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.37286,
    cy: 48.6111,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.49396,
    cy: 48.6111,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.6111,
    cy: 48.6111,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.7322,
    cy: 48.6111,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.8494,
    cy: 48.6111,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.9666,
    cy: 48.6111,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.0838,
    cy: 48.6111,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.2049,
    cy: 48.6111,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.3221,
    cy: 48.6111,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.4432,
    cy: 48.6111,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.5643,
    cy: 48.6111,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.37286,
    cy: 51.7283,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.49396,
    cy: 51.7283,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.6111,
    cy: 51.7283,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.7322,
    cy: 51.7283,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.8494,
    cy: 51.7283,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.9666,
    cy: 51.7283,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.0838,
    cy: 51.7283,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.2049,
    cy: 51.7283,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.3221,
    cy: 51.7283,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.4432,
    cy: 51.7283,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.5643,
    cy: 51.7283,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.37286,
    cy: 54.8484,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.49396,
    cy: 54.8484,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.6111,
    cy: 54.8484,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.7322,
    cy: 54.8484,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.8494,
    cy: 54.8484,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.9666,
    cy: 54.8484,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.0838,
    cy: 54.8484,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.2049,
    cy: 54.8484,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.3221,
    cy: 54.8484,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.4432,
    cy: 54.8484,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.5643,
    cy: 54.8484,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.37286,
    cy: 57.9666,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.49396,
    cy: 57.9666,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.6111,
    cy: 57.9666,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.7322,
    cy: 57.9666,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.8494,
    cy: 57.9666,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.9666,
    cy: 57.9666,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.0838,
    cy: 57.9666,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.2049,
    cy: 57.9666,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.3221,
    cy: 57.9666,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.4432,
    cy: 57.9666,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.5643,
    cy: 57.9666,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.37286,
    cy: 61.0858,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.49396,
    cy: 61.0858,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.6111,
    cy: 61.0858,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.7322,
    cy: 61.0858,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.8494,
    cy: 61.0858,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.9666,
    cy: 61.0858,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.0838,
    cy: 61.0858,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.2049,
    cy: 61.0858,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.3221,
    cy: 61.0858,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.4432,
    cy: 61.0858,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.5643,
    cy: 61.0858,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.37286,
    cy: 64.2039,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.49396,
    cy: 64.2039,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.6111,
    cy: 64.2039,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.7322,
    cy: 64.2039,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.8494,
    cy: 64.2039,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.9666,
    cy: 64.2039,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.0838,
    cy: 64.2039,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.2049,
    cy: 64.2039,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.3221,
    cy: 64.2039,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.4432,
    cy: 64.2039,
    r: 0.415833,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.5643,
    cy: 64.2039,
    r: 0.415833,
    fill: "#D9D9D9"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2778 56.1935H38.9016V55.5698H38.2778V56.1935ZM38.2778 65.0615V65.6853H38.9016V65.0615H38.2778ZM3.62438 65.0615H3.00063V65.6853H3.62438V65.0615ZM3.62438 57.5578L3.17244 57.1279L3.00063 57.3085V57.5578H3.62438ZM19.5868 40.7768L20.0387 41.2067L20.0479 41.1971L20.0566 41.1871L19.5868 40.7768ZM22.9976 36.4452L23.5137 36.7954L23.5165 36.7912L22.9976 36.4452ZM24.8735 32.9321L24.2925 32.7047L24.2884 32.7158L24.8735 32.9321ZM24.8394 26.5198L24.264 26.7607L24.2674 26.7688L24.2711 26.7769L24.8394 26.5198ZM22.9976 24.3028L22.6656 24.8309L22.6723 24.8351L22.9976 24.3028ZM14.8458 27.3725L14.2713 27.1294L14.2674 27.1389L14.8458 27.3725ZM14.1296 31.3631V31.9869H14.7533V31.3631H14.1296ZM2.60115 31.3631H1.9774V31.9869H2.60115V31.3631ZM4.81815 23.0067L4.282 22.6879L4.2799 22.6915L4.81815 23.0067ZM11.0599 16.9697L11.3663 17.5129L11.3698 17.5109L11.0599 16.9697ZM35.1058 21.3354L34.5659 21.648L34.5699 21.6547L35.1058 21.3354ZM36.1972 34.0576L35.6072 33.8553L36.1972 34.0576ZM33.8438 38.7986L34.364 39.1428L34.3663 39.1393L33.8438 38.7986ZM30.092 43.5737L29.629 43.1557L29.6258 43.1593L30.092 43.5737ZM25.1122 48.7921L24.6739 48.3484L24.6567 48.3654L24.6408 48.3837L25.1122 48.7921ZM18.7 56.1935L18.2286 55.7851L17.3343 56.8173H18.7V56.1935ZM37.6541 56.1935V65.0615H38.9016V56.1935H37.6541ZM38.2778 64.4378H3.62438V65.6853H38.2778V64.4378ZM4.24813 65.0615V57.5578H3.00063V65.0615H4.24813ZM4.07632 57.9877L20.0387 41.2067L19.1348 40.3469L3.17244 57.1279L4.07632 57.9877ZM20.0566 41.1871C21.4771 39.5604 22.6311 38.096 23.5137 36.7954L22.4814 36.0949C21.6359 37.341 20.516 38.7644 19.117 40.3666L20.0566 41.1871ZM23.5165 36.7912C24.3978 35.4692 25.0499 34.254 25.4586 33.1483L24.2884 32.7158C23.9239 33.7021 23.3254 34.8289 22.4786 36.0992L23.5165 36.7912ZM25.4543 33.1594C25.883 32.0638 26.1112 31.0415 26.1112 30.1011H24.8637C24.8637 30.8434 24.6825 31.7084 24.2926 32.7048L25.4543 33.1594ZM26.1112 30.1011C26.1112 28.6106 25.8871 27.3224 25.4077 26.2627L24.2711 26.7769C24.6558 27.6273 24.8637 28.7267 24.8637 30.1011H26.1112ZM25.4147 26.279C24.9604 25.1935 24.2651 24.3464 23.3228 23.7706L22.6723 24.8351C23.3672 25.2597 23.8998 25.8906 24.264 26.7607L25.4147 26.279ZM23.3295 23.7747C22.4115 23.1977 21.2999 22.9287 20.0302 22.9287V24.1762C21.1252 24.1762 21.9919 24.4074 22.6656 24.8309L23.3295 23.7747ZM20.0302 22.9287C18.7186 22.9287 17.5484 23.3103 16.5461 24.0813L17.3067 25.0701C18.078 24.4768 18.977 24.1762 20.0302 24.1762V22.9287ZM16.5461 24.0813C15.5621 24.8382 14.8073 25.8628 14.2714 27.1295L15.4203 27.6155C15.8848 26.5175 16.5171 25.6774 17.3067 25.0701L16.5461 24.0813ZM14.2674 27.1389C13.7556 28.4064 13.5058 29.8176 13.5058 31.3631H14.7533C14.7533 29.9526 14.981 28.7034 15.4242 27.6061L14.2674 27.1389ZM14.1296 30.7394H2.60115V31.9869H14.1296V30.7394ZM3.2249 31.3631C3.2249 28.4221 3.93678 25.7462 5.3564 23.3219L4.2799 22.6915C2.74352 25.3152 1.9774 28.2102 1.9774 31.3631H3.2249ZM5.35429 23.3255C6.79709 20.899 8.79679 18.9624 11.3663 17.5129L10.7534 16.4264C8.00213 17.9784 5.84069 20.0665 4.28201 22.6879L5.35429 23.3255ZM11.3698 17.5109C13.9231 16.0488 16.8944 15.3082 20.303 15.3082V14.0607C16.7083 14.0607 13.5174 14.8436 10.7499 16.4284L11.3698 17.5109ZM20.303 15.3082C23.9033 15.3082 26.8781 15.8678 29.2521 16.9568L29.7722 15.8229C27.1892 14.638 24.0245 14.0607 20.303 14.0607V15.3082ZM29.2521 16.9568C31.6246 18.0451 33.3861 19.6099 34.566 21.648L35.6456 21.0229C34.3243 18.7407 32.3566 17.0084 29.7722 15.8229L29.2521 16.9568ZM34.5699 21.6547C35.7745 23.6767 36.3921 26.1418 36.3921 29.0779H37.6396C37.6396 25.9655 36.9838 23.2691 35.6417 21.0162L34.5699 21.6547ZM36.3921 29.0779C36.3921 30.7391 36.13 32.3305 35.6072 33.8553L36.7873 34.2599C37.3559 32.6014 37.6396 30.873 37.6396 29.0779H36.3921ZM35.6072 33.8553C35.08 35.3931 34.3196 36.9273 33.3213 38.4579L34.3663 39.1393C35.4145 37.532 36.2231 35.9055 36.7873 34.2599L35.6072 33.8553ZM33.3236 38.4544C32.3205 39.9703 31.0899 41.5374 29.629 43.1557L30.5549 43.9916C32.05 42.3356 33.3207 40.7193 34.364 39.1428L33.3236 38.4544ZM29.6258 43.1593C28.181 44.7846 26.5306 46.5143 24.6739 48.3484L25.5506 49.2359C27.4229 47.3864 29.0924 45.637 30.5582 43.9881L29.6258 43.1593ZM24.6408 48.3837L18.2286 55.7851L19.1714 56.602L25.5837 49.2006L24.6408 48.3837ZM18.7 56.8173H38.2778V55.5698H18.7V56.8173Z",
    fill: "#202124"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.6126b7de804408fc93de90bbb36dbd62.svg";
export { ForwardRef as ReactComponent };